import { z } from 'zod'

export const schema = z.object({
  task_id: z.string(),
})

export type SchemaType = z.infer<typeof schema>
